import React, { useContext, useState } from 'react';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { TextProps as AntTextProps } from 'antd/lib/typography/Text';
import { Input, notification, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { AuthContext } from './Auth/Auth';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';

const { Text: AntText } = Typography;

export type TextProps = Omit<AntTextProps, 'children'> & {
  comcode: string;
  Inspectstyle?: React.CSSProperties;
};

const Text = ({ comcode, Inspectstyle, ...otherProps }: TextProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);
  const [newLabel, setNewLabel] = useState('');
  if (isHidden) {
    return null;
  }
  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };
  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '50%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  return <AntText {...props} />;
};

export default Text;
